import { css } from '@linaria/core';
import { theme } from '@terveystalo/design-system-theme';
const overrideColorStyle = css `
  color: var(--override-color);
`;
const overrideWeightStyle = css `
  font-weight: var(--override-weight);
`;
/**
 * Provides a mechanism to specify properties for specifying a dynamic color and font weight with defaults
 * in Linaria-based components.
 *
 * @param {object} [options] - Dynamic color and weight with default values
 * @returns an object with style and className properties which can be applied to
 *          the component in question
 */
export function getTypographyStyles({ color, weight, defaultColor, defaultWeight }) {
    const overrideColor = theme.color[color] || color;
    const className = [];
    const style = {};
    if (overrideColor) {
        className.push(overrideColorStyle);
        style['--override-color'] = overrideColor;
    }
    else if (defaultColor) {
        className.push(defaultColor);
    }
    if (weight) {
        className.push(overrideWeightStyle);
        style['--override-weight'] = weight;
    }
    else if (defaultWeight) {
        className.push(defaultWeight);
    }
    return { className, style };
}


import "../../../css/atoms/Typography/utils.css";
